import styled from 'styled-components';

import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';

export const ContentWrapper = styled.div`
  padding-block: 24px;
  display: flex;
  flex-direction: column;
  color: ${COLORS.systemDark300};
  gap: 24px;
`;

export const RoleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: ${COLORS.systemDark200};
`;

export const AvatarWrapper = styled.div`
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background-color: ${COLORS.statusTeal100};
  border: 2px solid ${COLORS.statusTeal300};
  color: ${COLORS.statusTeal300};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-size: 24px;

  &::before {
    content: '';
    position: absolute;
    border: 1px solid ${COLORS.statusTeal300};
    width: 52px;
    height: 52px;
    border-radius: 50%;
    opacity: 0.2;
  }

  &.isMember {
    background-color: ${COLORS.systemDark100};
    color: ${COLORS.systemLight100};
    border: 3px solid ${COLORS.systemLight100};

    &::before {
      border-color: ${COLORS.systemDark100};
    }
  }
`;

export const IntroTextWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-weight: 700;
  overflow: hidden;
`;

export const IntroName = styled.div`
  min-height: 20px;
  line-height: 20px;
`;

export const InfoPreview = styled.div`
  width: 100%;
  max-width: 250px;
  background-color: ${COLORS.systemLight200};
  padding: 16px 10px;
  border-radius: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

export const Text = styled.p`
  color: ${COLORS.systemDark200};
`;

export const IntroductionContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 8px;
`;

export const Introduction = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding-bottom: 24px;
`;

export const FormItems = styled.div`
  display: flex;
  gap: 24px;

  ${media.sm} {
    flex-direction: column;
    gap: 16px;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 16px;

  ${media.sm} {
    button {
      width: 100%;
    }
  }
`;
